module.exports = __webpack_public_path__ + "media/images/screenshots/sell-focus-9e9dfa7bbe6ded57c82fe0c28b4c3173.png";